export class AppConfig {
  baseApiUrl: string;
  baseBlobUrl: string;
  adClientId: string;

  merriHistoryApiUrl: string;
  merriTemplateApiUrl: string;
  merriUploadApiUrl: string;

  vendorHistoryApiUrl: string;
  vendorTemplateApiUrl: string;
  vendorUploadApiUrl: string;

  modelHistoryApiUrl: string;
  modelTemplateApiUrl: string;
  modelUploadApiUrl: string;
  modelDownloadAllApiUrl: string;
  modelUploadModelFilesUrl: string;

  materialHistoryApiUrl: string;
  materialTemplateApiUrl: string;
  materialUploadApiUrl: string;
  materialDownloadAllApiUrl: string;
  materialUploadMaterialFilesUrl: string;

  getGuidApiUrl: string;
  getManyGuidsApiUrl: string;
  getAllSubcategoriesUrl: string;
  variantSkusDownloadUrl: string;
  skuImagesScriptDownloadUrl: string;
  skuImageFilesUploadUrl: string;
  getValidAttributeValuesUrl: string;
  getAttributeInfoUrl: string;
  getVariantSkusByAttributeValueUrl: string;
  postCreateValidAttributeValueUrl: string;
  postUpdateValidAttributeValueUrl: string;
  getVariantSkusByTextUrl: string;
  postDiscontinueVendorSkuUrl: string;
  getVariantSkuByIdUrl: string;
  postEditSingleVariantSkuUrl: string;

  getVendorsAllsUrl: string;
  vendorUrl: string;
  postValidateVendorNameUrl: string;

  getVenuesAllApiUrl: string;
  getVenueApiUrl: string;
  postVenueApiUrl: string;
  postValidateVenueNameApiUrl: string;
  postVenueActiveApiUrl: string;
  getRoomApiUrl: string;
  postRoomApiUrl: string;
  postRoomActiveApiUrl: string;
  postValidatePartnerApiUrl: string;

  postDownloadMerriSkusApiUrl: string;
  postDownloadVariantSkusApiUrl: string;

  getVenueProvidedItemsApiUrl: string;
  downloadVenueProvidedItemsApiUrl: string;
  uploadVenueProvidedItemsApiUrl: string;
  postVenueProvidedItemApiUrl: string;
  getVenueEventPartnersApiUrl: string;
  getVenueEventPartnerUsersApiUrl: string;
  postVenueEventPartnerUsersApiUrl: string;
  getVenueShowroomPartnersApiUrl: string;
  getVenueShowroomPartnerUsersApiUrl: string;
  postVenueShowroomPartnerUsersApiUrl: string;

  getBlobContainersApiUrl: string;
  getBlobSearchFilesApiUrl: string;

  customRoomPropsApiUrl: string;
  customRoomPropsTemplateApiUrl: string;
  customRoomPropsUploadApiUrl: string;
  customRoomPropsImagesUploadApiUrl: string;
  customRoomPropsModelsUploadApiUrl: string;
  customRoomTexturesApiUrl: string;
  customRoomTexturesTemplateApiUrl: string;
  customRoomTexturesUploadApiUrl: string;
  customRoomTexturesImagesUploadApiUrl: string;
  customRoomTexturesMaterialsUploadApiUrl: string;
}
